import { render, staticRenderFns } from "./list-role.vue?vue&type=template&id=2d9607c0"
import script from "./list-role.vue?vue&type=script&lang=js"
export * from "./list-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports